import { render, staticRenderFns } from "./TaskGroup.vue?vue&type=template&id=194367c6&"
import script from "./TaskGroup.vue?vue&type=script&lang=js&"
export * from "./TaskGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports